import boatsetterPaths from 'utils/boatsetterPaths';
import { useAtom } from 'jotai';
// eslint-disable-next-line import/no-cycle
import { boatPathsAtom } from 'components/blw/blwStore';

export type PathType = `/a/list-boat${string}`;
interface NavReturnType {
  currentPath: PathType;
  previousPath: PathType;
  nextPath: PathType;
}
export interface PathsWithBoatType {
  home: PathType;
  details: PathType;
  international: PathType;
  insuranceType: PathType;
  commercial: PathType;
  location: PathType;
  title: PathType;
  cancellationPolicy: PathType;
  rules: PathType;
  features: PathType;
  photos: PathType;
  specifications: PathType;
  availability: PathType;
  startTimes: PathType;
  advanceNotice: PathType;
  multiBooking: PathType;
  duration: PathType;
  insurance: PathType;
  buoyInsuranceOwner: PathType;
  buoyInsuranceBoat: PathType;
  review: PathType;
}

export const getBLWPathsWithBoat = (boatId) => ({
  home: boatsetterPaths.listBoat as PathType,
  details: `${boatsetterPaths.listBoat}/${boatId}/details` as PathType,
  international: `${boatsetterPaths.listBoat}/${boatId}/international` as PathType,
  insuranceType: `${boatsetterPaths.listBoat}/${boatId}/insurance-type` as PathType,
  commercial: `${boatsetterPaths.listBoat}/${boatId}/commercial` as PathType,
  location: `${boatsetterPaths.listBoat}/${boatId}/location` as PathType,
  title: `${boatsetterPaths.listBoat}/${boatId}/title` as PathType,
  cancellationPolicy: `${boatsetterPaths.listBoat}/${boatId}/cancellation-policy` as PathType,
  rules: `${boatsetterPaths.listBoat}/${boatId}/rules` as PathType,
  features: `${boatsetterPaths.listBoat}/${boatId}/features` as PathType,
  photos: `${boatsetterPaths.listBoat}/${boatId}/photos` as PathType,
  specifications: `${boatsetterPaths.listBoat}/${boatId}/specifications` as PathType,
  availability: `${boatsetterPaths.listBoat}/${boatId}/availability` as PathType,
  startTimes: `${boatsetterPaths.listBoat}/${boatId}/start-times` as PathType,
  advanceNotice: `${boatsetterPaths.listBoat}/${boatId}/advance-notice` as PathType,
  multiBooking: `${boatsetterPaths.listBoat}/${boatId}/multi-booking` as PathType,
  duration: `${boatsetterPaths.listBoat}/${boatId}/duration` as PathType,
  insurance: `${boatsetterPaths.listBoat}/${boatId}/insurance` as PathType,
  buoyInsuranceOwner: `${boatsetterPaths.listBoat}/${boatId}/buoy-insurance-owner` as PathType,
  buoyInsuranceBoat: `${boatsetterPaths.listBoat}/${boatId}/buoy-insurance-boat` as PathType,
  review: `${boatsetterPaths.listBoat}/${boatId}/review` as PathType,
});

export const useGetBLWPathWithBoat = (args) => {
  const { boatId } = args;
  const [boatPaths, setBoatPaths] = useAtom(boatPathsAtom);
  let paths;
  if (boatPaths[boatId]) {
    paths = boatPaths[boatId];
  } else {
    const thesePaths = getBLWPathsWithBoat(boatId);
    const newPaths = {
      ...boatPaths,
      [boatId]: thesePaths,
    };
    setBoatPaths(newPaths);
    paths = thesePaths;
  }
  const returnVal = getNavigation(args, paths);
  return returnVal;
};

const blwPaths = getBLWPathsWithBoat('[id]');
const getNavigation = (
  {
    currentPath,
    insuranceType = '',
    boatId,
    isInternational = false,
    isReview,
    answer = '',
  }: {
    currentPath: PathType;
    insuranceType?: '' | 'p2p' | 'commercial' | string;
    boatId: string;
    isInternational?: boolean;
    isReview: boolean;
    answer?: string;
  },
  thisBoatBLWPaths: PathsWithBoatType
) => {
  const nav: NavReturnType = {
    currentPath,
    previousPath: '/a/list-boat',
    nextPath: '/a/list-boat',
  };

  switch (currentPath) {
    case blwPaths.home:
      nav.nextPath = thisBoatBLWPaths.details;
      break;
    case blwPaths.details:
      if (isInternational) {
        nav.nextPath = thisBoatBLWPaths.international;
      } else if (insuranceType === 'commercial') {
        nav.nextPath = thisBoatBLWPaths.commercial;
      } else {
        nav.nextPath = thisBoatBLWPaths.insuranceType;
      }
      nav.previousPath = `/a/list-boat`;
      break;
    case blwPaths.insuranceType:
      if (insuranceType === 'p2p') {
        nav.nextPath = `/a/list-boat/${boatId}/location`;
      } else {
        nav.nextPath = `/a/list-boat/${boatId}/commercial`;
      }
      nav.previousPath = `/a/list-boat/${boatId}/details`;
      break;
    case blwPaths.commercial:
      nav.nextPath = thisBoatBLWPaths.location;
      nav.previousPath = thisBoatBLWPaths.insuranceType;
      break;
    case blwPaths.location:
      nav.nextPath = thisBoatBLWPaths.title;
      if (isInternational) {
        nav.previousPath = thisBoatBLWPaths.international;
      } else if (insuranceType === 'p2p') {
        nav.previousPath = thisBoatBLWPaths.insuranceType;
      } else {
        nav.previousPath = thisBoatBLWPaths.commercial;
      }
      break;
    case blwPaths.international:
      nav.previousPath = thisBoatBLWPaths.details;
      nav.nextPath = thisBoatBLWPaths.location;
      break;
    case blwPaths.title:
      nav.nextPath = thisBoatBLWPaths.cancellationPolicy;
      nav.previousPath = thisBoatBLWPaths.location;
      break;
    case blwPaths.cancellationPolicy:
      nav.previousPath = thisBoatBLWPaths.title;
      nav.nextPath = thisBoatBLWPaths.rules;
      break;
    case blwPaths.rules:
      nav.nextPath = thisBoatBLWPaths.features;
      nav.previousPath = thisBoatBLWPaths.cancellationPolicy;
      break;
    case blwPaths.features:
      nav.nextPath = thisBoatBLWPaths.photos;
      nav.previousPath = thisBoatBLWPaths.rules;
      break;
    case blwPaths.photos:
      nav.previousPath = thisBoatBLWPaths.features;
      nav.nextPath = thisBoatBLWPaths.specifications;
      break;
    case blwPaths.specifications:
      nav.previousPath = thisBoatBLWPaths.photos;
      nav.nextPath = thisBoatBLWPaths.availability;
      break;
    case blwPaths.availability:
      nav.previousPath = thisBoatBLWPaths.specifications;
      if (answer === 'custom') {
        nav.nextPath = thisBoatBLWPaths.startTimes;
      } else {
        nav.nextPath = thisBoatBLWPaths.advanceNotice;
      }
      break;
    case blwPaths.startTimes:
      nav.previousPath = `/a/list-boat/${boatId}/availability`;
      nav.nextPath = `/a/list-boat/${boatId}/advance-notice`;
      break;
    case blwPaths.advanceNotice:
      // if the answer provided does not have custom start times
      if (answer === null) {
        nav.previousPath = thisBoatBLWPaths.availability;
      } else {
        nav.previousPath = thisBoatBLWPaths.startTimes;
      }
      nav.nextPath = thisBoatBLWPaths.multiBooking;
      break;
    case blwPaths.multiBooking:
      nav.previousPath = thisBoatBLWPaths.advanceNotice;
      nav.nextPath = thisBoatBLWPaths.duration;
      break;
    case blwPaths.duration:
      // answer in this case is isBuoy as a string
      if (answer === 'true' && insuranceType === 'p2p') {
        nav.nextPath = thisBoatBLWPaths.insurance;
      } else if (answer === 'true' && insuranceType === 'commercial') {
        nav.nextPath = thisBoatBLWPaths.buoyInsuranceOwner;
      } else {
        nav.nextPath = thisBoatBLWPaths.review;
      }
      nav.previousPath = thisBoatBLWPaths.multiBooking;
      break;
    case blwPaths.insurance:
      nav.nextPath = thisBoatBLWPaths.buoyInsuranceOwner;
      nav.previousPath = thisBoatBLWPaths.duration;
      break;
    case blwPaths.buoyInsuranceOwner:
      nav.nextPath = thisBoatBLWPaths.buoyInsuranceBoat;
      if (insuranceType === 'p2p') {
        nav.previousPath = thisBoatBLWPaths.insurance;
      } else {
        nav.previousPath = thisBoatBLWPaths.duration;
      }
      break;
    case blwPaths.buoyInsuranceBoat:
      nav.previousPath = thisBoatBLWPaths.buoyInsuranceOwner;
      nav.nextPath = thisBoatBLWPaths.review;
      break;
    default:
      break;
  }

  if (isReview) {
    nav.nextPath = thisBoatBLWPaths.review;
  }

  return nav;
};

export default getNavigation;
